export const categoriesGraph = [
    {
        id: 1,
        name: 'Cene stoke',
        title: 'Cene stoke na pijacama',
        title_path: 'cene-stoke-na-pijacama'
    },
    {
        id: 2,
        name: 'Cene voća',
        title: 'Cene voća na pijacama',
        title_path: 'cene-voca-na-pijacama'
    },
    {
        id: 3,
        name: 'Cene žitarica',
        title: 'Cene žitarica na pijacama',
        title_path: 'cene-zitarica-na-pijacama'
    },
  
    {
        id: 5,
        name: 'Cene jaja i mleka',
        title: 'Cene jaja i mleka na pijacama',
        title_path: 'cene-jaja-i-mleka-na-pijacama'
    },
    {
        id: 6,
        name: 'Cene povrća',
        title: 'Cene povrća na pijacama',
        title_path: 'cene-povrca-na-pijacama'
    }
];